import { getMomentTz, MESApiService } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import moment from "moment";
import {
	WaterAccount,
	WaterAccountAllocation,
	WaterAccountMeter,
	WaterAccountsData,
	WaterAllocationTarget,
} from "../models/WaterAccount";

const momentTz = getMomentTz();

export const getWaterAccounts = async (
	signal?: AbortSignal,
): Promise<WaterAccountsData> => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[USG].[GetWaterAccounts]", [], signal);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching water accounts");
	}

	const tables = get(resp, "data.tables", {});

	return {
		accounts: (get(tables, "0.rows", []) as WaterAccount[]).map((row) => ({
			WaterAccountId: row.WaterAccountId,
			AccountNumber: row.AccountNumber,
			Location: row.Location,
			Description: row.Description,
			MeterCount: row.MeterCount,
			BillCount: row.BillCount,
			LastServicePeriodEnd: row.LastServicePeriodEnd
				? moment.utc(row.LastServicePeriodEnd).toDate()
				: null,
			UnpaidBillCount: row.UnpaidBillCount,
			IsSelectable: row.IsSelectable,
			IsActive: row.IsActive,
		})),
		meters: (get(tables, "1.rows", []) as WaterAccountMeter[]).map((row) => ({
			MeterId: row.MeterId,
			WaterAccountId: row.WaterAccountId,
			ExternalMeterId: row.ExternalMeterId,
			MeterNumber: row.MeterNumber,
			MeterSerial: row.MeterSerial,
			MeterSize: row.MeterSize,
			AssetId: row.AssetId,
			MillName: row.MillName,
			Description: row.Description,
			IsActive: row.IsActive,
		})),
		allocations: (get(tables, "2.rows", []) as WaterAccountAllocation[]).map(
			(row) => ({
				WaterAccountId: row.WaterAccountId,
				TargetId: row.TargetId,
				TargetCode: row.TargetCode,
				TargetName: row.TargetName,
				AssetId: row.AssetId,
				AllocationPercent: row.AllocationPercent,
				DisplayOrder: row.DisplayOrder,
			}),
		),
		targets: (get(tables, "3.rows", []) as WaterAllocationTarget[]).map(
			(row) => ({
				TargetId: row.TargetId,
				TargetCode: row.TargetCode,
				TargetName: row.TargetName,
				AssetId: row.AssetId,
				AssetName: row.AssetName,
				IsActive: row.IsActive,
			}),
		),
	};
};
